module.exports = __webpack_public_path__ + "static/sky4-cfb44344294c8a1e00f0526331c81de3.jpg";